import React, { Component } from 'react'
import { Modal } from 'antd';
import { connect } from 'react-redux'
import { hideMiscModal } from '../../redux/actions/miscActions'
import GradProcesBar from './GradProcesBar';
import ToelagenForm from './ToelagenForm';
import InhoudingenForm from './InhoudingenForm';

export class MiscModal extends Component {

  closeModal=()=>{
    this.props.hideMiscModal()
  }

  render() {
    const {isMiscModalVisible,
      miscModalType,
      miscModalContent} = this.props.misc
    return (
      <div className='misc-modal-container'>
        <Modal
          className="misc-modal"
          visible={isMiscModalVisible}
          footer={null}
          onCancel={this.closeModal}
          closable={false}
          centered={true}
        >
          {miscModalContent === 'progess-bar' ? <GradProcesBar /> : null}
          {miscModalContent === 'toelagen' ? <ToelagenForm /> : null}
          {miscModalContent === 'inhoudingen' ? <InhoudingenForm /> : null}
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) =>({
  misc: state.misc
})

export default connect(mapStateToProps, {hideMiscModal})(MiscModal)
